import type { MapaCargo } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'
import { REDATOR_SECOES_A } from '@/components/Configuracao/mapaCargos/data/cargo-redator-secoes-a'
import { REDATOR_SECOES_B } from '@/components/Configuracao/mapaCargos/data/cargo-redator-secoes-b'

export const CARGO_REDATOR: MapaCargo = {
  id: 'redator',
  titulo: 'Redator',
  setor: 'Criação',
  secoes: [...REDATOR_SECOES_A, ...REDATOR_SECOES_B],
}
